module.exports = __webpack_public_path__ + "media/slide1/contractMediaSlide1Part2New-1e87037f.png";